import { render, staticRenderFns } from "./Presupuesto.vue?vue&type=template&id=4cb47191"
import script from "./Presupuesto.vue?vue&type=script&lang=js"
export * from "./Presupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports